/* CAPPONI — Pestañas del cajón: BOLSA | FAVORITOS.
 *
 * El cajón nativo de Horizon sigue sirviendo el carrito tal cual; aquí solo se
 * añade una segunda vista al lado y se conmuta entre las dos. Nada de lo que
 * hace el carrito se toca, para no romper el flujo de compra.
 */
(function () {
  if (window.CapponiCartTabs) return;
  window.CapponiCartTabs = true;

  var W = function () {
    return window.CapponiWishlist;
  };

  function panelCarrito(raiz) {
    return raiz.querySelector('.cart-drawer__content, .cart-items-component, [data-capponi-cart-panel]');
  }

  function mostrar(raiz, cual) {
    var favs = raiz.querySelector('[data-capponi-fav-panel]');
    var carro = panelCarrito(raiz);
    if (!favs || !carro) return;

    var esFav = cual === 'favoritos';
    favs.toggleAttribute('hidden', !esFav);
    carro.style.display = esFav ? 'none' : '';

    raiz.querySelectorAll('[data-capponi-tab]').forEach(function (b) {
      var activo = b.dataset.capponiTab === cual;
      b.classList.toggle('is-activo', activo);
      b.setAttribute('aria-selected', activo ? 'true' : 'false');
    });

    // El pie del cajón (finalizar compra) no pinta nada en favoritos.
    var pie = raiz.querySelector('.cart-drawer__summary, cart-summary');
    if (pie) pie.style.display = esFav ? 'none' : '';

    if (esFav) pintar(raiz);
  }

  /* Fila: foto | (nombre + precio con Quitar al lado) | boton.
     El Quitar va pegado al precio, no debajo del boton de anadir: son acciones
     opuestas y juntarlas invita a pulsar la que no es. El boton queda centrado
     en vertical para que no baile segun lo largo que sea el nombre. */
  function plantillaItem(p) {
    var agotado = p.agotado === true;
    return (
      '<div class="cap-fav-item" data-handle="' + p.handle + '">' +
      (p.imagen ? '<img class="cap-fav-item__img" src="' + p.imagen + '" alt="" loading="lazy">' : '<span class="cap-fav-item__img"></span>') +
      '<div class="cap-fav-item__datos">' +
      '<p class="cap-fav-item__nombre">' + (p.titulo || p.handle) + '</p>' +
      '<div class="cap-fav-item__linea">' +
      (agotado
        ? '<span class="cap-fav-item__agotado">Agotado</span>'
        : '<span class="cap-fav-item__precio">' + (p.precio || '') + '</span>') +
      '<button type="button" class="cap-fav-item__quitar" data-fav-quitar="' + p.handle + '">Quitar</button>' +
      '</div>' +
      '</div>' +
      (agotado || !p.varianteId
        ? '<a class="cap-fav-item__add" href="' + p.url + '">VER</a>'
        : '<button type="button" class="cap-fav-item__add" data-fav-add="' + p.varianteId + '">AÑADIR</button>') +
      '</div>'
    );
  }

  async function pintar(raiz) {
    var wl = W();
    if (!wl) return;
    var cont = raiz.querySelector('[data-capponi-fav-lista]');
    var vacio = raiz.querySelector('[data-capponi-fav-vacio]');
    var aviso = raiz.querySelector('[data-capponi-fav-aviso]');
    if (!cont) return;

    var lista = wl.lista();
    cont.innerHTML = lista.map(plantillaItem).join('');
    if (vacio) vacio.toggleAttribute('hidden', lista.length > 0);
    if (aviso) aviso.toggleAttribute('hidden', lista.length === 0);

    if (!lista.length) return;

    // Precio y disponibilidad al día: el retrato guardado puede ser viejo.
    var frescos = await wl.refrescar();
    cont.innerHTML = frescos.map(plantillaItem).join('');
  }

  document.addEventListener('click', async function (ev) {
    var tab = ev.target.closest('[data-capponi-tab]');
    if (tab) {
      ev.preventDefault();
      var raiz = tab.closest('cart-drawer-component, dialog, .cart-drawer') || document;
      mostrar(raiz, tab.dataset.capponiTab);
      return;
    }

    var quitar = ev.target.closest('[data-fav-quitar]');
    if (quitar) {
      ev.preventDefault();
      W() && W().quitar(quitar.dataset.favQuitar);
      var r1 = quitar.closest('cart-drawer-component, dialog, .cart-drawer') || document;
      pintar(r1);
      return;
    }

    var pliegue = ev.target.closest('[data-cap-ups-toggle]');
    if (pliegue) {
      ev.preventDefault();
      var filaPlegable = pliegue.closest('.cap-ups__fila--plegable');
      if (filaPlegable) {
        var cerrada = filaPlegable.classList.toggle('is-cerrada');
        pliegue.setAttribute('aria-expanded', cerrada ? 'false' : 'true');
      }
      return;
    }

    var pick = ev.target.closest('[data-cap-ups-pick]');
    if (pick) {
      ev.preventDefault();
      var item = pick.closest('.cap-ups__item');
      var tallas = item && item.querySelector('.cap-ups__tallas');
      if (tallas) {
        if (tallas.hasAttribute('hidden')) {
          tallas.removeAttribute('hidden');
          pick.setAttribute('aria-expanded', 'true');
        } else {
          tallas.setAttribute('hidden', '');
          pick.setAttribute('aria-expanded', 'false');
        }
      }
      return;
    }

    var ups = ev.target.closest('[data-cap-ups-add]');
    if (ups) {
      ev.preventDefault();
      anadirVariante(ups, ups.dataset.capUpsAdd);
      return;
    }

    var add = ev.target.closest('[data-fav-add]');
    if (add) {
      ev.preventDefault();
      anadirVariante(add, add.dataset.favAdd);
    }
  });

  // Añade una variante sin recargar la página. Recargar cerraba el cajón y
  // devolvía al cliente a la portada justo cuando estaba más cerca de pagar.
  // La vía estándar (Shopify.actions.updateCart) emite el evento que el cajón
  // de Horizon ya escucha: la lista se re-renderiza sola y el cajón sigue
  // abierto. El botón no cambia de texto ni de tamaño mientras tanto: solo
  // marca aria-busy y el CSS hace latir su contenido.
  //
  // Blindaje (02/09): la vía estándar puede fallar en silencio (editor de
  // temas, userErrors, API ausente). Nunca se da por buena sin comprobar que
  // el carrito creció de verdad; si no creció, vía directa /cart/add.js y
  // recarga como último recurso. Añadir siempre gana a no recargar.
  async function cuentaCarrito() {
    try {
      var r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      var c = await r.json();
      return typeof c.item_count === 'number' ? c.item_count : null;
    } catch (e) {
      return null;
    }
  }

  // Mientras se añade (y un momento después, cuando el cajón se re-renderiza
  // bajo el dedo), el toque fantasma del móvil puede aterrizar en cualquier
  // cosa: el enlace de una fila (navega a la ficha) o incluso fuera del panel
  // si el nodo tocado ya no existe — theme-drawer lo lee como clic en el
  // fondo y CIERRA el cajón. Durante la ventana se traga todo clic que no
  // sea de los controles propios (añadir otra pieza sí debe poder hacerse
  // en cadena).
  var CONTROLES_PROPIOS =
    '[data-cap-ups-add], [data-cap-ups-pick], [data-cap-ups-toggle], .cap-ups__talla, [data-fav-add], [data-fav-quitar], [data-capponi-tab]';
  var bloqueoNav = false;
  var bloqueoTimer = null;
  function bloquearNav(ms) {
    bloqueoNav = true;
    if (bloqueoTimer) clearTimeout(bloqueoTimer);
    bloqueoTimer = setTimeout(function () {
      bloqueoNav = false;
    }, ms);
  }
  document.addEventListener(
    'click',
    function (ev) {
      if (!bloqueoNav) return;
      if (ev.target instanceof Element && ev.target.closest(CONTROLES_PROPIOS)) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
    },
    true
  );

  // Cinturón y tirantes: si pese a todo el cajón se cierra en plena ventana
  // (un cierre que el cliente no ha pedido), se reabre al vuelo.
  document.addEventListener(
    'close',
    function (ev) {
      if (!bloqueoNav) return;
      var cajon = ev.target instanceof Element && ev.target.closest('#cart-drawer');
      if (!cajon || typeof cajon.open !== 'function') return;
      setTimeout(function () {
        if (bloqueoNav && !cajon.isOpen) cajon.open();
      }, 60);
    },
    true
  );

  async function anadirVariante(boton, varianteId) {
    if (boton.disabled) return;
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');
    bloquearNav(1500);
    var acciones = window.Shopify && window.Shopify.actions;
    var antes = await cuentaCarrito();

    if (acciones && acciones.updateCart) {
      try {
        var res = await acciones.updateCart({ lines: [{ merchandiseId: String(varianteId), quantity: 1 }] });
        var conErrores = res && res.userErrors && res.userErrors.length;
        if (!conErrores) {
          var despues = await cuentaCarrito();
          if (antes === null || despues === null || despues > antes) {
            // Añadido de verdad: el cajón se re-renderiza solo por el evento.
            // El re-pintado llega AHORA, así que la ventana de bloqueo se
            // renueva desde este momento, no desde el inicio del añadido.
            bloquearNav(1500);
            boton.disabled = false;
            boton.removeAttribute('aria-busy');
            return;
          }
        }
      } catch (e) {
        // cae a la vía directa
      }
    }

    // Vía directa: garantiza el añadido aunque la API estándar no esté o
    // falle (p. ej. dentro del editor). La recarga es el precio de que el
    // cajón nativo se entere; solo se paga en este camino de emergencia.
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(varianteId), quantity: 1 }] }),
      });
      if (r.ok) {
        window.location.reload();
        return;
      }
    } catch (e) {
      // sin red: se restaura y el cliente puede reintentar
    }
    boton.disabled = false;
    boton.removeAttribute('aria-busy');
  }

  // Al abrir el cajón siempre se entra por la bolsa.
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('[on\\:click*="cart-drawer"], [href="/cart"], .header-actions__cart')) return;
    setTimeout(function () {
      var raiz = document.querySelector('cart-drawer-component');
      if (raiz) mostrar(raiz, 'carrito');
    }, 350);
  });

  document.addEventListener('capponi:favoritos:cambio', function () {
    var raiz = document.querySelector('cart-drawer-component');
    if (!raiz) return;
    var favs = raiz.querySelector('[data-capponi-fav-panel]');
    if (favs && !favs.hasAttribute('hidden')) pintar(raiz);
  });
})();
